/* Home hero: on phones, size the photo so the buttons sit on its lower edge without covering the flowers. */
(function () {
  'use strict';
  function fit(sec) {
    var media = sec.querySelector('.hero-media'), im = media && media.querySelector('img'), cta = sec.querySelector('.hero-foot');
    if (!im || !cta) return;
    function run() {
      if (!document.contains(im)) return;
      if (window.innerWidth >= 900) { im.style.height = ''; return; }
      var M = media.clientHeight, free = M - (cta.offsetHeight + 14);
      im.style.height = Math.round(Math.max(200, Math.min(M, free / 0.68))) + 'px';
    }
    run(); window.addEventListener('resize', run);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(run);
  }
  function all() { Array.prototype.forEach.call(document.querySelectorAll('[data-hero]'), fit); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
